import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueSessionStorage from "vue-sessionstorage";
import "./plugins/vuetify-mask.js";
import { store } from './store';


//Mixin
import "./mixins/global.js";

Vue.config.productionTip = false
Vue.use(VueSessionStorage);


//VueCryptojs
import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs)


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
